import React, { useContext, useState } from "react";
import { Formik, Field } from "formik";
import {
    TextField,
    Button,
    Grid,
    Switch,
    Typography,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Send } from "@material-ui/icons";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { TimePicker } from "formik-material-ui-pickers";

import { UserContext, OrderContext } from "../../context";
import { setUserWithId, addOrder } from "../../services/firestore";
import {
    isDeveloperDev,
    isDev,
    isDeliverConditionFullfilled,
    isPartnerDev,
    getPartnerName,
} from "../../helpers";
import { NoDeliverAlert, PrettyJSON } from "..";

const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
    },
    item: {},
}));

const Basic = (props) => {
    const { user } = useContext(UserContext);
    const { orders, setOrders } = useContext(OrderContext);
    const classes = useStyles();
    const [isDelivery, setIsDelivery] = useState(false);
    const [CantDeliverAlert, setCantDeliverAlert] = useState(false);
    const toogleIsDelivery = () => setIsDelivery(!isDelivery);
    const filialeCities = Object.keys(props.partnerLocations ?? []);
    const [isSubmitted, setSubmitted] = props.isSubmitted;

    function handleValidation(values) {
        const errors = {};
        function existValidation(field) {
//             if (!field) {
//                 return "Leere Eingabe.";
//             }
            return null;
        }

        function addressValidation(address) {
            const regex = /^([A-ZÄÖÜ][a-zäöüß ]+(([.] )|( )|([-])))+[1-9][0-9]{0,3}[-\/]?[a-z]?[1-9]{0,3}$/;
            // match Eybacherstr. 11/1, Eybacherstr. 11-1, Eybacher straße 11b, Ey ba cher straße 11b
            if (!address.match(regex))
                return `Ungültige Addresse. z.B. "Beispielstraße 11/1"`;
            return null;
        }

        function zipValidation(zip) {
            const regex = /^[0-9]{5}$/;
            if (!zip.match(regex)) return 'Ungültige PLZ. z.B. "70327"';
            return null;
        }

        function emailValidation(email) {
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email))
                return `Ungültige Email Eingabe. z.B. "example@email.com"`;
            return null;
        }

        for (let field of ["name", "tel", "email", "location"]) {
            const existResult = existValidation(values[field]);
            if (existResult) errors[field] = existResult;
            if (field === "email") {
                const addressResult = emailValidation(values[field]);
                if (addressResult) errors[field] = addressResult;
            }
        }

        if (isDelivery) {
            for (let field of ["address1", "city", "zip", "deliverTime"]) {
                const existResult = existValidation(values[field]);
                if (existResult) errors[field] = existResult;
                if (field === "address1") {
                    const addressResult = addressValidation(values[field]);
                    if (addressResult) errors[field] = addressResult;
                }
                if (field === "zip") {
                    const addressResult = zipValidation(values[field]);
                    if (addressResult) errors[field] = addressResult;
                }
            }
        }

        if (!isDelivery) {
            for (let field of ["takeTime"]) {
                const existResult = existValidation(values[field]);
                if (existResult) errors[field] = existResult;
            }
        }
        return errors;
    }

    async function handleSubmit(values, { setSubmitting }) {
        const userProfile = {
            ...user,
            ...values,
        };
        delete userProfile.wish;
        delete userProfile.deliverTime;
        delete userProfile.takeTime;
        values.deliverCost = props.deliverCost;
        if (values.deliverTime) {
            values.deliverTime = values.deliverTime.toLocaleString();
        }
        if (values.takeTime) values.takeTime = values.takeTime.toLocaleString();

        if (isDelivery) values.takeTime = "";
        values.method = isDelivery ? "Lieferung" : "Abholen";

        const sendContent = {
            content: {
                contactInfo: values,
                order: orders,
                uid: user.uid,
            },
        };

        return addOrder(sendContent)
            .then((orderID) => props.setOrderID(orderID))
            .then(() =>
                setUserWithId({
                    id: user.uid,
                    content: userProfile,
                })
            )
            .then(() => {
                setSubmitting(false);
                setSubmitted(true);
                if (isDeveloperDev) {
                    alert(JSON.stringify(sendContent, null, 2));
                    alert(JSON.stringify(userProfile, null, 2));
                }
            });
    }

    function queryDistance(values, errors) {
        const errorKey = Object.keys(errors);
        if (
            isDelivery &&
            values.address1 &&
            values.zip &&
            !errorKey.includes("address1") &&
            !errorKey.includes("zip")
        ) {
            const address = {
                partnerAddress: props.partnerLocations[values.location],
                customerAddress: [
                    values.address1,
                    values.address2,
                    values.zip,
                ].join(" "),
            };
            props.handleAddress(address);
        }
    }

    const formItems = {
        publicInput: [
            {
                type: "text",
                label: "Exetra Wunsch",
                name: "wish",
                multiline: true,
            },
            {
                type: "text",
                label: "Name",
                name: "name",
            },
            {
                type: "tel",
                label: "Tel.",
                name: "tel",
            },
            {
                type: "email",
                label: "Email",
                name: "email",
            },
        ],
        publicSelect: [
            {
                type: "select",
                label: "Filiale",
                name: "location",
                items: filialeCities,
            },
        ],
        deliverInput: [
            {
                type: "time",
                label: `Bitte geben Ihre erwartete Lieferzeit (min. 30 Minuten später${
                    getPartnerName().toLowerCase() === "komari"
                        ? ", von 12:00 bis 20:30"
                        : ""
                }) `,
                name: "deliverTime",
            },
            {
                type: "text",
                label: "Adresse",
                name: "address1",
            },
            {
                type: "text",
                label: "Adresse Hinweis",
                name: "address2",
            },
            {
                type: "text",
                label: "PLZ",
                name: "zip",
            },
            {
                type: "text",
                label: "Stadt",
                name: "city",
            },
        ],
        noDeliverInput: [
            {
                type: "time",
                label: `Bitte geben Ihre Abholenzeit (min. 30 Minuten später${
                    getPartnerName().toLowerCase() === "komari"
                        ? ", von 12:00 bis 21:00"
                        : ""
                })  `,
                name: "takeTime",
            },
        ],
    };

    return (
        <>
            {CantDeliverAlert ? (
                <NoDeliverAlert
                    setOpen={setCantDeliverAlert}
                    noDeliverExplaination={props.deliverCondition?.explaination}
                />
            ) : null}
            <Grid>
                <Typography variant="h4" gutterBottom>
                    Kontakt Information
                </Typography>
                <Formik
                    initialValues={{
                        location: "",
                        method: "Abholen",
                        wish: "",
                        name: user.name ?? "",
                        tel: user.tel ?? "",
                        email: user.email ?? "",
                        deliverTime: "",
                        address1: user.address1 ?? "",
                        address2: user.address2 ?? "",
                        city: user.city ?? "",
                        zip: user.zip ?? "",
                        takeTime: "",
                    }}
                    validate={handleValidation}
                    onSubmit={handleSubmit}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        /* and other goodies */
                    }) => {
                        queryDistance(values, errors);

                        const inputElement = ({
                            type,
                            label,
                            name,
                            helperText,
                            ...args
                        }) => (
                            <Grid item key={name} xs={12} sm={6} lg={3}>
                                <TextField
                                    type={type}
                                    label={label}
                                    variant="outlined"
                                    id={name}
                                    name={name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values[name]}
                                    error={
                                        touched[name] && Boolean(errors[name])
                                    }
                                    helperText={touched[name] && errors[name]}
                                    rowsMax={7}
                                    fullWidth
                                    multiline={args.multiline ?? false}
                                />
                            </Grid>
                        );

                        const selectElement = ({
                            label,
                            name,
                            helperText,
                            items,
                            defaultValue,
                        }) => (
                            <Grid item key={name} xs={12} sm={6} lg={3}>
                                <FormControl
                                    variant="outlined"
                                    fullWidth
                                    error={
                                        touched[name] && Boolean(errors[name])
                                    }
                                >
                                    <InputLabel
                                        id={`${label}-select-outlined-label`}
                                    >
                                        {label}
                                    </InputLabel>
                                    <Select
                                        labelId={`${label}-select-outlined-label`}
                                        id={name}
                                        name={name}
                                        value={values[name]}
                                        defaultValue={defaultValue}
                                        label={label}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    >
                                        {items.map((item) => (
                                            <MenuItem key={item} value={item}>
                                                {item}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText>
                                        {touched[name] && errors[name]}
                                    </FormHelperText>
                                </FormControl>
                            </Grid>
                        );

                        const inputTime = ({ name, label }) => (
                            <Grid item xs={12} sm={6} lg={3} key={name}>
                                {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Field
                    component={TimePicker}
                    clearable
                    ampm={false}
                    id={name}
                    name={name}
                    label={label}
                    value={values[name]}
                    onChange={handleChange}
                  />
                </MuiPickersUtilsProvider> */}
                                <TextField
                                    type="text"
                                    label={label}
                                    variant="outlined"
                                    id={name}
                                    name={name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values[name]}
                                    fullWidth
                                />
                            </Grid>
                        );

                        const isDeliveryBtn = (
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                lg={3}
                                component="label"
                                container
                                alignItems="center"
                                spacing={1}
                            >
                                <Grid item>
                                    <Typography>Abholen</Typography>
                                </Grid>
                                <Grid item>
                                    <Switch
                                        id="isDelivery"
                                        checked={isDelivery}
                                        onChange={() => {
                                            if (
                                                !isDeliverConditionFullfilled(
                                                    orders,
                                                    props.deliverCondition
                                                        ?.minTotal,
                                                    props.deliverCondition
                                                        ?.busyHour
                                                )
                                            ) {
                                                setIsDelivery(false);
                                                setCantDeliverAlert(true);
                                            } else toogleIsDelivery();
                                        }}
                                        value={values.isDelivery}
                                    />
                                </Grid>
                                <Grid item>
                                    <Typography>Lieferung</Typography>
                                </Grid>
                            </Grid>
                        );

                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={3} alignItems="center">
                                    <Grid item container spacing={3}>
                                        {formItems.publicInput.map((item) =>
                                            inputElement(item)
                                        )}
                                    </Grid>
                                    <Grid item container spacing={3}>
                                        {formItems.publicSelect.map((item) =>
                                            selectElement(item)
                                        )}
                                    </Grid>
                                    {isDeliveryBtn}
                                    <Grid item container spacing={3}>
                                        {isDelivery
                                            ? formItems.deliverInput.map(
                                                  (item) =>
                                                      item.type === "time"
                                                          ? inputTime(item)
                                                          : inputElement(item)
                                              )
                                            : formItems.noDeliverInput.map(
                                                  (item) => inputTime(item)
                                              )}
                                    </Grid>
                                    <Grid item container spacing={3}>
                                        <Button
                                            type="submit"
                                            disable={String(isSubmitting)}
                                            variant="contained"
                                            color="secondary"
                                            className={classes.button}
                                            endIcon={<Send />}
                                        >
                                            Send
                                        </Button>
                                        {isSubmitting && (
                                            <CircularProgress color="inherit" />
                                        )}
                                    </Grid>
                                </Grid>
                                {isDeveloperDev && (
                                    <PrettyJSON
                                        json={{ values, errors }}
                                        keyLabel="deliverForm"
                                        isLimitWidth
                                    />
                                )}
                            </form>
                        );
                    }}
                </Formik>
            </Grid>
        </>
    );
};

export default Basic;
